export default __webpack_public_path__ + "static/media/mizrahi-header.568ffcc5.png";